module.exports = __webpack_public_path__ + "static/media/sun.26258939.png";